import apolloClient from 'apollo-client'
import {GET_WINE_CLUB_MEMBERSHIPS} from './graphql'
import {
  UPDATE_WINE_CLUB_SUBSCRIPTION_PAYMENT_METHOD_MANY,
  WINE_CLUB_SUBSCRIPTION_BILLING_ADDRESS_UPDATE,
  WINE_CLUB_SUBSCRIPTION_PAYMENT_METHOD_UPDATE,
  WINE_CLUB_SUBSCRIPTION_SHIPPING_ADDRESS_UPDATE,
} from './graphql/membership'
import {IWineClubSubscriptionPaymentMethodUpdate} from 'app/features/wine-clubs/wine-club-package/view-package/packageMembers/Customer/CustomerPayment'
import {IWineClubSubscriptionAddressUpdate} from 'app/features/wine-clubs/wine-club-package/view-package/packageMembers/Customer/CustomerAddress'
import {IUpdateWineClubSubscriptionPaymentMethodMany} from 'app/features/wine-clubs/models'

class MembershipService {
  async getWineClubMembers(params: any) {
    const {data} = await apolloClient.query({
      query: GET_WINE_CLUB_MEMBERSHIPS,
      variables: params,
    })
    return {data: data.searchSubscriptions.nodes, totalCount: data.searchSubscriptions.totalCount}
  }

  async wineClubSubscriptionPaymentMethodUpdate(
    membership: IWineClubSubscriptionPaymentMethodUpdate
  ) {
    const {errors} = await apolloClient.mutate({
      mutation: WINE_CLUB_SUBSCRIPTION_PAYMENT_METHOD_UPDATE,
      variables: {membership},
    })
    if (errors) {
      throw errors
    }
  }

  async wineClubSubscriptionAddressUpdate(membership: IWineClubSubscriptionAddressUpdate) {
    const {errors} = await apolloClient.mutate({
      mutation: WINE_CLUB_SUBSCRIPTION_SHIPPING_ADDRESS_UPDATE,
      variables: {membership},
    })
    if (errors) {
      throw errors
    }
  }

  async wineClubSubscriptionBillingAddressUpdate(membership: IWineClubSubscriptionAddressUpdate) {
    const {errors} = await apolloClient.mutate({
      mutation: WINE_CLUB_SUBSCRIPTION_BILLING_ADDRESS_UPDATE,
      variables: {membership},
    })
    if (errors) {
      throw errors
    }
  }

  async updateWineClubSubscriptionPaymentMethodMany(
    input: IUpdateWineClubSubscriptionPaymentMethodMany
  ) {
    const {errors} = await apolloClient.mutate({
      mutation: UPDATE_WINE_CLUB_SUBSCRIPTION_PAYMENT_METHOD_MANY,
      variables: {input},
    })
    if (errors) {
      throw errors
    }
  }
}

const membershipService = new MembershipService()

export default membershipService
